export default class Navigation {
  constructor(dom) {
    this.dom = dom;
    this.updateNavHeightCssVar();
    window.addEventListener("resize", () => this.resize());
  }

  setHideOnScroll() {
    this.hidden = false;
    this.oldTop = window.scrollY;
    window.addEventListener("scroll", () => {
      let currTop = window.scrollY;
      if (currTop > this.oldTop + 10 && this.hidden == false) {
        this.hideElement();
      } else if (currTop < this.oldTop - 5 && this.hidden == true) {
        this.showElement();
      }
      this.oldTop = currTop;
    });
  }

  hideElement() {
    this.dom.classList.add("shy");
    this.hidden = true;
  }

  showElement() {
    this.dom.classList.remove("shy");
    this.hidden = false;
  }

  updateNavHeightCssVar() {
    document.body.style.setProperty(
      "--navHeight",
      `${this.dom.clientHeight}px`
    );
  }
  menuControl() {
    const menuButton = this.dom.querySelector("[js-menu-btn]");
    const menu = this.dom.querySelector("[js-ham]");
    const overlay = this.dom.querySelector("[js-menuoverlay]");
    let menuOpened = false;

    menuButton.addEventListener("click", () => {
      if (menuOpened == false) {
        menu.classList.add("active");
        overlay.classList.add("active");
        menuOpened = true;
      } else {
        menu.classList.remove("active");
        overlay.classList.remove("active");
        menuOpened = false;
      }
    });
  }

  searchBoxControl() {
    const searchBox = document.querySelector("[js-search-box]");
    const searchButton = this.dom.querySelector("[js-search-btn]");
    const closeButton = document.querySelector("[js-search-close]");

    const mSearchButton = this.dom.querySelector("[js-m-search-btn]");
    const mLightBox = document.querySelector("#lightbox-search");
    let closeBtns = document.querySelectorAll(".close-btn");
    let searchOpened = false;

    searchButton.addEventListener("click", () => {
      if (searchOpened == false) {
        searchBox.classList.add("active");
        searchOpened = true;
      } else {
        searchBox.classList.remove("active");
        searchOpened = false;
      }
    });

    closeButton.addEventListener("click", () => {
      searchBox.classList.remove("active");
      searchOpened = false;
    });

    mSearchButton.addEventListener("click", () => {
      mLightBox.classList.add("opened");
      closeBtns.forEach((btn) => {
        btn.addEventListener("click", function (e) {
          mLightBox.classList.remove("opened");
        });
      });
    });
  }

  resize() {
    this.updateNavHeightCssVar();
    // console.log("resize from Navigation.js");
  }
}
